import { NAVMENUS_REQUEST, NAVMENUS_RECEIVED } from 'redux/actions/nav-menus';

const initialState = {
  hasError: false,
  navMenus: {},
  loading: true,
};

export default function navMenus(state = initialState, action) {
  switch (action.type) {
    case NAVMENUS_REQUEST:
      return Object.assign({}, state, {
        hasError: false,
        data: {
          ...state.navMenus,
        },
        loading: true,
      });
    case NAVMENUS_RECEIVED:
      return Object.assign({}, state, {
        hasError: false,
        data: {
          ...state.navMenus,
          ...action.navMenus,
        },
        loading: false,
      });
    default:
      return state;
  }
}
